import apiClient from '../api/axios';

export interface Module {
  id: string;
  title: string;
  description?: string;
  [key: string]: any;
}

export interface AssignOrganizationModulesPayload {
  organizationId: string;
  moduleIds: string[];
}

export interface OrganizationModule {
  id: string;
  organizationId: string;
  moduleIds: string[];
}

// Get Modules
export const getModules = async () => {
  const response = await apiClient.get('/modules');

  return response.data;
};

// Assign Modules to Organization
export const assignOrganizationModules = async (data: AssignOrganizationModulesPayload) => {
  const response = await apiClient.post('/organization-modules', data);

  return response.data;
};
